import { render, staticRenderFns } from "./SpaceConfigurationLfs.vue?vue&type=template&id=235cdd3e&"
import script from "./SpaceConfigurationLfs.vue?vue&type=script&lang=js&"
export * from "./SpaceConfigurationLfs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports